/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserRemoteRoles {
  RemoteConsignor = 'remote_consignor',
  RemoteConsignee = 'remote_consignee',
  RemoteCarrier = 'remote_carrier'
}
